import React, { useEffect, useState } from "react";
import { AiOutlineCloseCircle, AiOutlinePlusCircle } from "react-icons/ai";
import Button from "../../commonComponent/Button";
import { addProvider, getCareTeamProvider } from "../../services/CareTeam";
import { showToastError, showToastSuccess } from "../../Utils/Helper";
import { getCategories } from "../../services/DoctorService";
import { ImSpinner8 } from "react-icons/im";
import { useCareTeamContext } from "../../Context/CareTeamContext";

const AddProviders = () => {

  const {setAllProvider} = useCareTeamContext()


  const getAllProviders = async () => {
    try {
      const response = await getCareTeamProvider();
      if (response.status !== 200) {
        return;
      }
      setAllProvider(response?.data?.data)
    } catch (error) {
      console.log(error);
    }
  };

  const initialFormValues = [
    { email: "", full_name: "", role: "", category: "", first_name:"", last_name:"" },
  ]

  const [formValues, setFormValues] = useState(initialFormValues);
  const [error, setError] = useState(false);
  const [isLoading, setLoader] = useState(false);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const getCategoryList = async () => {
      try {
        const response = await getCategories();
        if (response.status === 200) {
          setCategories(response?.data?.data);
        } else {
          showToastError(response?.data || response.message);
        }
      } catch (error) {
        error?.data?.data &&
          showToastError(error?.data?.data || error.data?.message);
      }
    };
    getCategoryList();
    setFormValues(initialFormValues)
  }, []);

  let addFormFields = () => {
    setFormValues([
      ...formValues,
      { email: "", full_name: "", role: "", category: "", first_name:"", last_name:"" },
    ]);
  };

  const handleChange = (index, event) => {
    const { name, value } = event.target;
    const newFormValues = [...formValues];
    newFormValues[index][name] = value;
    newFormValues[index]['first_name'] = formValues[index]["full_name"].split(" ")[0]
    newFormValues[index]['last_name'] = formValues[index]["full_name"].split(" ")[1]

    setFormValues(newFormValues);
  };

  const hasEmptyValue = (arr) => {
    return arr.some((obj) => {
      // Check if any property in the object is falsy
      return Object.values(obj).some((value) => !value);
    });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);
    if (hasEmptyValue(formValues)) {
      setError(true);
      showToastError("Please fill all details");
      setLoader(false);
      return;
    }

    let payload = {
      EmailList: formValues,
    };

    try {
      if (payload) {
        const response = await addProvider(payload);
        if (response.status === 200) {
          await getAllProviders()
          showToastSuccess(response.data.data[0]);
          setFormValues(initialFormValues)
          setLoader(false);
        } else {
          showToastError("Send invitation failed");
          setLoader(false);
        }
      } else {
        setLoader(false);
        return;
      }
    } catch (error) {
      console.log(error);
    }
  };

  let removeFormFields = (i) => {
    let newFormValues = [...formValues];
    newFormValues.splice(i, 1);
    setFormValues(newFormValues);
  };
  return (
    <>
      <div
        class="modal fade"
        id="addproviders"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog viewteam_width8">
          <div class="modal-content">
            <div class="modal-header p-4">
              <h5 className="mb-0">
                Add your providers
                {/* <AiOutlinePlusCircle
                  onClick={() => addFormFields()}
                  className="list_plusicon"
                /> */}
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body pb-4 px-4">
              <form>
                <div className="row">
                  <div className="col-md-3 mb-2">
                    <label className="form-label" htmlFor="members">
                      Email Address
                    </label>
                  </div>

                  <div className="col-md-3  mb-2">
                    <label className="form-label" htmlFor="members">
                      First & Last Name
                    </label>
                  </div>

                  <div className="col-md-3  mb-2">
                    <label className="form-label" htmlFor="members">
                      Title/Role
                    </label>
                  </div>

                  <div className="col-md-3  mb-2">
                    <label className="form-label" htmlFor="members">
                      Category
                    </label>
                  </div>
                  <div className="col-md-12">
                    {formValues.map((element, index) => (
                      <div
                        className="row"
                        key={index}
                        style={{ marginBottom: "-10px" }}
                      >
                        <div className="col-md-3">
                          <input
                            className="form-control description_inputf mb-2"
                            type="email"
                            id="email"
                            name="email"
                            value={element.gmail}
                            pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
                            placeholder="e.g. sharonjames@gmail.com"
                            onChange={(e) => handleChange(index, e)}
                            required
                          />
                        </div>

                        <div className="col-md-3">
                          <input
                            className="form-control description_inputf mb-2"
                            type="text"
                            id="full_name"
                            value={element.name}
                            name="full_name"
                            placeholder="e.g. Clara M Cardenas"
                            onChange={(e) => handleChange(index, e)}
                          />
                        </div>

                        <div className="col-md-3">
                          <div className="btn-group w-100">
                            <select
                              name="role"
                              id="role"
                              value={element.role}
                              className="description_inputf"
                              onChange={(e) => handleChange(index, e)}
                            >
                              <option value="" disabled>Please select</option>
                              <option value="Lead Physician">
                                Lead Physician
                              </option>
                              <option value="Case Manager">Case Manager</option>
                              <option value="Care Coordinator">
                                Care Coordinator
                              </option>
                              <option value="Admin">Admin</option>
                              <option value="Group Moderator">
                                Group Moderator
                              </option>
                              <option value="Collaborating Physician">
                                Collaborating Physician
                              </option>
                              <option value="Nurse Practitioner">
                                Nurse Practitioner{" "}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="btn-group w-100">
                            {/* <select
                              name="category"
                              id="category"
                              value={element.category}
                              className="description_inputf"
                              onChange={(e) => handleChange(index, e)}
                            >
                              <option value="category">Please select</option>
                              <option value="Lead Physician">
                                Nutritionist
                              </option>
                              <option value="Case Manager">Case Manager</option>
                              <option value="Care Coordinator">
                                Dietician
                              </option>
                              <option value="Admin">Admin</option>
                              <option value="Group Moderator">
                                Immunologist
                              </option>
                              <option value="Collaborating Physician">
                                Health Educator
                              </option>
                              <option value="Nurse Practitioner">
                                Cardiologist{" "}
                              </option>
                            </select> */}
                            <select
                              name="category"
                              id="category"
                              className="description_inputf mb-1"
                              value={element.category}
                              onChange={(e) => handleChange(index, e)}
                            >
                              <option disabled value="">
                                Select Category
                              </option>
                              {categories.length &&
                                categories.map((dt) => (
                                  <option key={dt._id} value={dt.name}>
                                    {dt.name}
                                  </option>
                                ))}
                            </select>
                            {index > 0 ? (
                              <button
                                type="button"
                                title="Remove"
                                style={{ height: "55px" }}
                                className="btn btn-outline-danger px-2 ms-2 rounded"
                                onClick={() => removeFormFields(index)}
                              >
                                <AiOutlineCloseCircle
                                  style={{ marginTop: "-4px" }}
                                  size="22px"
                                />
                              </button>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    ))}
                    <Button
                      type={"button"}
                      text={
                        <>
                          <AiOutlinePlusCircle size={22} stroke="white" />
                          <span>Add More Provider</span>
                        </>
                      }
                      style={{ fontSize: "16px" }}
                      onClick={() => addFormFields()}
                      className="description_btnsave gap-1 d-flex justify-content-between align-items-center fw-normal "
                    />
                  </div>
                </div>

                <hr />
                <div className="d-flex justify-content-between mt-1">
                  <button
                    type="button"
                    className="btn btn-outline-secondary px-4"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <Button
                     data-bs-dismiss={ hasEmptyValue(formValues) ? "" : "modal"}
                    isLoading={isLoading}
                    loadingText={<ImSpinner8 />}
                    text={"Send Invitation"}
                    className={"btn btn-primary btn-custom"}
                    onClick={(e) => handleSubmit(e)}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddProviders;
